import React from "react";

const AnteProyectoIcon = ({ className = "" }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
    className={className}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M9 12.325v2m-3-2v3m6-3v3m6-3v3m-3-3v2m-12-11v4m0-2h18m0-2v4m-1.125 5c.621 0 1.125.512 1.125 1.143v5.714c0 .631-.504 1.143-1.125 1.143H4a1 1 0 0 1-1-1v-5.857c0-.63.504-1.143 1.125-1.143z"
    ></path>
  </svg>
);

export default AnteProyectoIcon;